import { HelpCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export default function HelpTip({ title = 'Ayuda', content }) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" className="inline-flex items-center justify-center text-white/35 hover:text-white/70 transition-colors" data-testid={`help-tip-${title.toLowerCase().replace(/\s+/g, '-')}`}>
            <HelpCircle className="w-4 h-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs bg-[#0a0c12] text-white border border-white/10 px-3 py-2">
          <p className="text-[11px] font-semibold mb-1">{title}</p>
          <p className="text-[10px] text-white/75 whitespace-pre-wrap">{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}